import React, { useEffect, useRef, useState } from "react";
import { Button, Form, message, Upload, Tooltip, Image } from "antd";
import { UploadOutlined, InfoCircleOutlined, FileExcelOutlined } from "@ant-design/icons";
import { accountDataModel } from "./accountDataModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants"
import { useDetailModel } from "../detailModel";
import { accountService, creditFlagDs } from "@/views/account/AccountService";
import { useLockFn } from "ahooks";
import FontIcon from "@/components/YhIcon";
import { UploadChangeParam } from "antd/lib/upload";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { UploadFile } from "antd/lib/upload/interface";
import { getBaseImgLookUrl } from "@/utils/constants";
import "@/views/contract/manage/contract-style.less";

export const AdjustMonthDrawer = () => {
    const { getSelectedDict } = useGlobalModel();
    const { beDs, orgDs } = useDetailModel();
    const {
        selectedData, adjustMonthDrawerVisible,
        onReset, setAdjustMonthDrawerVisible,
    } = accountDataModel();

    const formRef = useRef<IYhFormRef>();
    const [contractType, setContractType] = useState<string>();
    const [uploadFileList, setUploadFileList] = useState<any>([]);
    const [previewOpen, setPreviewOpen] = useState<boolean>(false);
    const [previewImage, setPreviewImage] = useState<any>();

    useEffect(() => {
        if (adjustMonthDrawerVisible) {
            formRef.current?.setFieldsValue({
                ...selectedData[0],
            })
        }
    }, [adjustMonthDrawerVisible])

    const normFile = (e: UploadChangeParam) => {
        let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc", ".xls", ".xlsx"];
        let isType: boolean = false;
        let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf("."));
        isType = filetypes?.includes(fileEnd) ?? false;
        console.log('Upload event:', e);
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                    url: getBaseImgLookUrl(e.file.response.retData),
                }
                e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e;
        }
        if (!isType) {
            e.fileList?.pop()
        }
        return e && e.fileList;
    };

    const contractTypeChange = (value: string, option: any) => {
        if (value) {
            setContractType(value);
            if (value == "contract-type.month") {
                formRef.current?.setFieldsValue({ type: 0 });
            }
            if (value == "contract-type.frame") {
                formRef.current?.setFieldsValue({ type: 1 });
            }
        }
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分支",
                fieldName: "branch",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户",
                fieldName: "code",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户",
                fieldName: "name",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                disable: true,
                span: 24,
                ds: creditFlagDs(),
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "机构",
                fieldName: "orgCode",
                disable: true,
                span: 24,
                treeDs: orgDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "实体",
                fieldName: "beCode",
                disable: true,
                span: 24,
                ds: beDs
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <><Tooltip placement="topLeft" title={(<span> 签约类型为月结协议时，如到期日还存在可用额度，根据合同结束日期顺延10日对该月结账户下授信额度做清0处理。<br />签约类型为临时授信时，额度最长保留10日，10日后不管使没使用都将对该临时调整额度做清0处理。</span>)}><InfoCircleOutlined /></Tooltip><span>签约类型</span></>,
                fieldName: "contractType",
                ds: getSelectedDict(DictCodeEnmu.CONTRACT_TYPE),
                onSelectChange: contractTypeChange,
                rules: [{
                    required: true,
                    message: "请选择月结类型!"
                }],
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调额类型',
                fieldName: "type",
                disable: true,
                span: 24,
                ds: [
                    {
                        label: "目标调额",
                        value: 0
                    },
                    {
                        label: "增量调额",
                        value: 1
                    }
                ]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "调整额度",
                fieldName: "contractAmount",
                span: 24,
                rules: [{
                    required: true,
                    pattern: new RegExp(/^[+]?(\d+)$|^[+]?(\d+\.\d+)$/),
                    message: "请输入大于等于0的数字!"
                }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "起始日期",
                fieldName: "startTime",
                format: "YYYY-MM-DD",
                rules: [{
                    required: contractType != "contract-type.frame",
                    message: "请选择起始日期!"
                }],
                disable: contractType == "contract-type.frame",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "结束日期",
                fieldName: "endTime",
                format: "YYYY-MM-DD",
                rules: [{
                    required: contractType != "contract-type.frame",
                    message: "请选择结束日期!"
                }],
                disable: contractType == "contract-type.frame",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "附件",
                fieldName: "file",
                span: 24,
                colClassName: "ant-col-h-auto",
                formItem: <Form.Item
                    name="fileList"
                    label="附件"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    rules={[
                        {
                            required: true,
                            message: '请上传附件信息'
                        }
                    ]}
                >
                    <Upload
                        name="file"
                        className="AdjustMonthDrawerUpload"
                        action={getBaseImgUploadUrl()}
                        data={getBaseUploadData()}
                        // headers={{
                        //     authorization: getToken()
                        // }}
                        listType="picture"
                        fileList={uploadFileList}
                        maxCount={1}
                        // disabled={editModel === 'look'}
                        beforeUpload={(file) => {
                            let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
                            // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                            let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc", ".xls", ".xlsx"];
                            // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                            let isType = filetypes?.includes(fileEnd);
                            if (!isType) {
                                message.error('不支持该格式的上传,当前仅支持 图片、pdf、xls、xlsx和.doc 类型文件');
                            }
                            const isLt20M = file.size / 1024 / 1024 < 20;
                            if (!isLt20M) {
                                message.error('上传到文件不能超过20M');
                            }
                            return isType && isLt20M;
                        }}
                        iconRender={(file) => {
                            if (file?.type?.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                            if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                            if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            if (file?.type?.indexOf('sheet') !== -1 || file?.type?.indexOf('excel') !== -1) return <FileExcelOutlined />
                        }}
                        onChange={(info) => {
                            if (info.file.status === 'done') {
                                let md5 = info.file.response.retData;
                                let list: UploadFile[] = info.fileList;
                                for (let index = 0; index < list.length; index++) {
                                    let e = list[index];
                                    e.thumbUrl = getBaseImgLookUrl(md5);
                                    e.url = getBaseImgLookUrl(md5);
                                }
                                setUploadFileList(info.fileList);
                            }
                        }}
                        onPreview={(file) => {
                            if (file?.type?.indexOf('pdf') != -1 ||
                                file?.type?.indexOf('msword') != -1 ||
                                file?.type?.indexOf('sheet') !== -1 ||
                                file?.type?.indexOf('excel') !== -1) {
                                window.location.href = file?.url ?? "";
                            }
                            else {
                                setPreviewImage(file?.url);
                                setPreviewOpen(true);
                            }
                        }}
                    >
                        <Button icon={<UploadOutlined />}>选择文件上传</Button>
                    </Upload>
                </Form.Item>
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "remark",
                span: 24,
            },
        ]
    };

    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const { fileList = [] } = formData
                const reqData = {
                    "accountCode": formData.code,
                    "contractAmount": formData.contractAmount,
                    "contractType": formData.contractType,
                    "type": formData.type,
                    "note": formData.remark,
                    "startTime": formData.startTime?.format('YYYY-MM-DD 00:00:00'),
                    "endTime": formData.endTime?.format('YYYY-MM-DD 23:59:59'),
                    "md5": "",
                    "fileName": "",
                    "fileSize": 0,
                };

                if (fileList.length > 0) {
                    const file = fileList[0];
                    if (!file?.uid) {
                        console.log(file);
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    if (file?.status) {
                        console.log(file);
                        return message.warn('文件正在上传，请等待文件上传成功！')
                    }
                    reqData.md5 = file?.uid;
                    reqData.fileName = file.name;
                    reqData.fileSize = file.size;
                }
                let insertRet = await accountService.adjustMonth(reqData);
                if (insertRet.success) {
                    message.success("调额申请成功!");
                    onReset();
                    setAdjustMonthDrawerVisible(false);
                } else {
                    message.error("调额失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    });

    const onCancel = () => {
        setAdjustMonthDrawerVisible(false);
    };

    return (
        <AppDrawer
            {...{
                title: "账户调额",
                visible: adjustMonthDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </AppDrawer>
    )
}
